import React, { useEffect } from "react";
import { ScientistBtn } from "./ScientistBtn";
import { Typography } from "@mui/material";
import WhiteArrowLeft from "../../assets/images/WhiteArrowLeft.png";
import { EduCrousal } from "./EduCrousal";
import "aos/dist/aos.css";
import { convertImagePathToUrl } from "../../utils";

const formatModalDescription = (description) =>
  description?.replace(/(\r\n|\r|\n)/g, "<br>");

export const Educator = ({ educators, advocacy }) => {
  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll(".aos-init");

      elements.forEach((el) => {
        const rect = el.getBoundingClientRect();
        const triggerPoint = window.innerHeight / 2;

        if (rect.top < triggerPoint) {
          el.style.transitionDuration = "0.2s";
          el.style.transitionTimingFunction = "cubic-bezier(0.4, 0, 1, 2)";
          el.classList.add("aos-animate");
        }
      });
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  if (educators?.length === 0 && advocacy?.length === 0) return;

  return (
    <div id="The Educator">
      <div
        style={{
          backgroundColor: "#EBEEF3",
          overflowX: "hidden",
          overflowY: "hidden",
        }}
      >
        <div
          className="h-full md:h-[700px] flex justify-between"
          data-aos="fade-left"
        >
          <div className="justify-end hidden lg:flex" style={{ flex: 1 }}>
            <img
              src={WhiteArrowLeft}
              className="h-full ml-auto leftArrowStyle"
              alt="White Arrow Left"
            />
          </div>

          <div
            className="flex flex-col items-center py-10 bg-white"
            style={{ flex: 2 }}
          >
            <div className="py-10 mx-20 lg:mx-0" style={{ maxWidth: "580px" }}>
              <Typography
                className="font-bold text-4xl"
                style={{
                  fontFamily: "Montserrat",
                }}
              >
                {educators?.section_heading}
              </Typography>

              {/* Mobile view image (hidden on lg screens) */}
              <div className="lg:hidden flex justify-center my-4">
                {educators?.details?.[0]?.assets?.[0]?.images?.map(
                  (img, imgIndex) => (
                    <img
                      key={imgIndex}
                      src={convertImagePathToUrl(img.image_url)}
                      className="h-full ml-auto leftArrowStyle"
                      alt="Educator"
                    />
                  )
                )}
              </div>

              {educators?.details?.[0]?.singleArray?.map((det, ind) => (
                <React.Fragment key={ind}>
                  {det?.key === "sub-heading" && (
                    <Typography
                      className="mt-5"
                      style={{
                        fontSize: 16,
                        fontWeight: 600,
                        fontFamily: "Montserrat",
                      }}
                    >
                      {det?.sub_heading}
                    </Typography>
                  )}

                  {det?.key === "sub-heading" && (
                    <Typography
                      className="mx-auto"
                      style={{
                        fontSize: 14,
                        fontWeight: 500,
                        fontFamily: "Montserrat",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: formatModalDescription(det?.sub_heading_desc),
                      }}
                    />
                  )}

                  {det?.key === "btt" && (
                    <div className="flex justify-start pb-10">
                      <ScientistBtn Sbutton1={det?.childButtons} />
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>

          <div className="hidden bg-white lg:block" style={{ flex: 1 }}>
            {educators?.details?.[0]?.assets?.[0]?.images?.map(
              (img, imgIndex) => (
                <img
                  key={imgIndex}
                  src={convertImagePathToUrl(img.image_url)}
                  className="h-full ml-auto leftArrowStyle"
                  alt="Educator"
                />
              )
            )}
          </div>
        </div>
      </div>

      <div className="pt-20">
        <EduCrousal advocacy={advocacy} />
      </div>
    </div>
  );
};
